// extracted by mini-css-extract-plugin
export default {"modal":"fkpZk_r7FaxytpwZ5jQq","modalOverlay":"g8j34edYrQAHkVfQPX9A","modalTitle":"wDnfrAvn1XPvyHxOLUVB","modalDescription":"ybhwwa3S9SPL_xawGmlp","modalBtns":"LR6fwmoddJEZVpxIuR2m"};